import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Styles from '../../../../../assets/js/Styles';
import { ExternalMediaModel, isVimeoMediaModel } from '../../../../../declarations/models/ExternalMediaModel';
import Container from '../../../../../components/Container';
import { getVimeoPlaybackUrl } from '../../../../../utils/url';
import { ChildrenProp } from '../../../../../declarations/ChildrenProp';

export interface VimeoContentProps {
  item: ExternalMediaModel;
}

export const VimeoContent: FC<VimeoContentProps & ChildrenProp> = ({ item }) => {
  const { t: tComponents } = useTranslation('components');
  if (!isVimeoMediaModel(item)) {
    console.error('VimeoContent rendered with an incorrect model. This should never happen.');
    return null;
  }

  return (
    <Container p={2} top left fullWidth column>
      <Container
        fullWidth
        left
        top
        sx={{
          backgroundColor: Styles.Colors.LIGHTEST_BLUE,
          p: 2,
        }}>
        <Typography>
          {tComponents('MediaBlock.ExternalContentMessage')}

          <Typography sx={{ mt: 1 }}>
            <strong>VIMEO ID:</strong> {item.local?.vimeoId} <br />
            <strong>Embed/iframe URL:</strong> {item.local.anySource}
          </Typography>
        </Typography>
      </Container>
      <Box
        component='iframe'
        width='560px'
        height='315px'
        src={getVimeoPlaybackUrl(item.local?.vimeoId) || ''}
        title='Vimeo video player'
        allow='autoplay; fullscreen; picture-in-picture'
        allowFullScreen
        sx={{
          border: 'none',
        }}
      />
    </Container>
  );
};

export default VimeoContent;
